import React from "react";
import {
  Modal,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
} from "@mui/material";

interface CreateOptionsModalProps {
  open: boolean;
  onClose: () => void;
  selectedOptionType: string;
  setSelectedOptionType: (value: string) => void;
  selectedExistingOption: string;
  setSelectedExistingOption: (value: string) => void;
  onContinue: () => void;
  options: any[];
}

const CreateOptionsModal: React.FC<CreateOptionsModalProps> = ({
  open,
  onClose,
  selectedOptionType,
  setSelectedOptionType,
  selectedExistingOption,
  setSelectedExistingOption,
  onContinue,
  options,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400, md: 600 },
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <h2
          style={{
            marginBottom: "16px",
            fontSize: "1.25rem",
            fontWeight: "bold",
          }}
        >
          Create New Option
        </h2>
        <div className="space-y-4">
          <p>Check these instructions if you need help creating your option.</p>
          <p>
            All option titles should follow the same format so customers can
            distinguish between them easily, e.g. Guided Tour in English, Guided
            Tour in Spanish, etc.
          </p>
          <p>
            Remember to edit existing option titles if you’re adding extra
            options.
          </p>
        </div>
        <RadioGroup
          value={selectedOptionType}
          onChange={(e) => setSelectedOptionType(e.target.value)}
          style={{ display: "flex", flexDirection: "column", gap: "8px" }}
        >
          <FormControlLabel
            value="new"
            control={<Radio />}
            label="Create new option"
          />
          <FormControlLabel
            value="template"
            control={<Radio />}
            label="Use existing option as a template"
          />
        </RadioGroup>
        {selectedOptionType === "template" && (
          <FormControl fullWidth>
            <InputLabel id="existing-option-label">Select Option</InputLabel>
            <Select
              labelId="existing-option-label"
              value={selectedExistingOption}
              onChange={(e) => setSelectedExistingOption(e.target.value)}
            >
              {options.map((option) => (
                <MenuItem key={option._id} value={option._id}>
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
            marginTop: "16px",
          }}
        >
          <button
            className="h-12 px-6 font-bold text-gray-700 border border-gray-500 rounded-md"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            className="h-12 px-6 font-bold text-white bg-primary1 rounded-md"
            onClick={onContinue}
          >
            Continue
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default CreateOptionsModal;
